<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 18 18" enable-background="new 0 0 18 18" xml:space="preserve">
<path fill="currentColor" d="M15.893,7.628l-2.274-3.779H7v8.201L9.688,18C10.709,18,12,17.172,12,16.15v-4.423h1.575
C15.68,11.728,16.979,9.431,15.893,7.628z"/>
<rect fill="currentColor" x="2" y="3.801" width="3" height="8"/>
</svg>
